import { useCallback, useEffect, useRef, useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

export const useHorizontalScroll = () => {
  const ref = useRef(null);
  const [edges, setEdges] = useState({ left: false, right: true });

  const update = useCallback(() => {
    const el = ref.current;
    if (!el) return;
    setEdges({
      left: el.scrollLeft > 4,
      right: el.scrollLeft + el.clientWidth < el.scrollWidth - 4,
    });
  }, []);

  useEffect(() => {
    update();
    window.addEventListener("resize", update);
    return () => window.removeEventListener("resize", update);
  }, [update]);

  const scrollBy = (dir) => {
    const el = ref.current;
    if (!el) return;
    const card = el.firstElementChild;
    const gap = parseFloat(getComputedStyle(el).columnGap) || 0;
    const step = card ? card.getBoundingClientRect().width + gap : el.clientWidth;
    el.scrollBy({ left: dir * step, behavior: "smooth" });
  };

  return { ref, edges, update, scrollBy };
};

const arrowCls =
  "w-11 h-11 rounded-full border border-[#E8E5DF] bg-white text-[#2C2B29] flex items-center justify-center shadow-[0_4px_16px_rgba(0,0,0,0.05)] hover:border-[#C96A4E] hover:text-[#C96A4E] transition-colors duration-200 disabled:opacity-35 disabled:pointer-events-none";

export const ScrollArrows = ({ edges, scrollBy, testIdPrefix }) => (
  <div className="hidden md:flex items-center gap-2 shrink-0">
    <button
      type="button"
      aria-label="Previous treatments"
      data-testid={`${testIdPrefix}-prev`}
      onClick={() => scrollBy(-1)}
      disabled={!edges.left}
      className={arrowCls}
    >
      <ChevronLeft size={20} />
    </button>
    <button
      type="button"
      aria-label="Next treatments"
      data-testid={`${testIdPrefix}-next`}
      onClick={() => scrollBy(1)}
      disabled={!edges.right}
      className={arrowCls}
    >
      <ChevronRight size={20} />
    </button>
  </div>
);
